module.exports = __webpack_public_path__ + "img/banner.d48c8542.jpg";